import { render, staticRenderFns } from "./AddColorProductComponent.vue?vue&type=template&id=6ffd87e7&scoped=true"
import script from "./AddColorProductComponent.vue?vue&type=script&lang=js"
export * from "./AddColorProductComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffd87e7",
  null
  
)

export default component.exports